import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-black text-gray-400 text-sm px-6 py-12 border-t border-gray-800 shadow-inner">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10">
        
        {/* 🔗 External Links */}
        <div className="space-y-3 text-center md:text-left">
          <Link
            to="/careers1"
            className="flex items-center gap-2 text-blue-400 hover:text-white hover:underline transition duration-200"
          >
            <span>💼</span> Apply for jobs  ↗
          </Link>
          <a
            href="#"
            className="flex items-center gap-2 text-blue-400 hover:text-white hover:underline transition duration-200"
          >
            <span>🌐</span> Learn more  ↗
          </a>
        </div>

        {/* 📜 Legal Links */}
        <div className="flex flex-wrap justify-center md:justify-start gap-4 text-gray-500 text-xs">
          {["Privacy", "Cookie", "Do not sell", "Sitemap", "Accessibility"].map((label, index) => (
            <span
              key={index}
              className="hover:text-white cursor-pointer transition duration-200"
            >
              {label}
            </span>
          ))}
        </div>

        {/* 🌍 Language Selector */}
        <div>
          <select className="bg-gray-800 text-white text-xs px-4 py-2 rounded-full focus:outline-none border border-gray-700">
            <option>English</option>
            <option>Hindi</option>
            <option>Spanish</option>
          </select>
        </div>
      </div>

      {/* 🧾 Bottom Note */}
      <div className="mt-10 text-center text-xs text-gray-600">
        © {new Date().getFullYear()} The Prisu Experts. All rights reserved.
      </div>
    </footer>
  );
}
